<div class="fontSet flex h-[750px] justify-center">
  <div class="left-container flex flex-col items-center justify-center gap-12">
    <p class="min-w-60">
      You can contact us at any of the <br />
      below options during regular <br />
      business hours (M-F 8a-5p).
    </p>
    <div class="contact-grid">
      <div class="border-container-l">
        <div class="dotted-border mb-10">
          <div>
            <img class="contact-icon" ngSrc="assets/images/contact-phone.png" height="48" width="48" alt="Call" />
            <p><strong>CALL</strong></p>
            <p>
              (330) <strong>673-9515</strong><br />
              ext <strong>TIME</strong> (8463)
            </p>
          </div>
        </div>
      </div>
      <div class="border-container-m">
        <div class="dotted-border mb-12">
          <div>
            <img class="contact-icon" ngSrc="assets/images/contact-text.png" height="48" width="48" alt="Text" />
            <p><strong>TEXT</strong></p>
            <p>(330) <strong>642-4330</strong></p>
          </div>
        </div>
      </div>
      <div class="border-container-r">
        <div class="dotted-border">
          <div>
            <img class="contact-icon" ngSrc="assets/images/contact-email.png" height="48" width="48" alt="Email" />
            <p><strong>EMAIL</strong></p>
            <p>
              DaveyTimeSupport <br />
              &#64;Davey.com
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="relative mx-4 flex w-full flex-col justify-center" [formGroup]="form">
    <div class="flex justify-center">
      <p class="help-flyer text-center text-white"><strong>NEED HELP?</strong></p>
    </div>
    <div>
      <p class="mb-4">
        Please fill out the field below to submit a Helpdesk Ticket to the Davey Time Team. Tickets are responded to during
        regular business hours (M-F 8a-5p)
      </p>

      <h3>
        <label for="help-message">
          Let us know what we can help you with.
          <span class="text-2xl text-red-600">*</span>
        </label>
      </h3>
      <mat-form-field appearance="outline" class="w-full">
        <textarea class="min-h-20" matInput required id="help-message" name="help-message" formControlName="message"></textarea>
        @if (form.controls['message']?.invalid) {
          <mat-error>Please enter a message</mat-error>
        }
      </mat-form-field>

      <h3>
        Select the best way to contact you.
        <span class="text-2xl text-red-600">*</span>
      </h3>

      @if (shouldShowPhoneOrEmailMessage) {
        <mat-error class="mb-2">Please enter either a phone number or an email address</mat-error>
      }

      <label for="help-phone">Phone</label>
      <mat-form-field appearance="outline" class="w-full">
        <input
          matInput
          id="help-phone"
          name="help-phone"
          type="tel"
          placeholder="(555) 123-4567"
          formControlName="phoneNumber"
          (blur)="formatPhoneNumber()"
        />
        @if (form.controls['phoneNumber']?.invalid) {
          <mat-error>Please enter a valid phone number (including area code)</mat-error>
        }
      </mat-form-field>

      <label for="help-email">Email</label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput id="help-email" name="help-email" type="email" formControlName="email" />
        @if (form.controls['email']?.invalid) {
          <mat-error>Please enter a valid email address</mat-error>
        }
      </mat-form-field>
    </div>

    <button type="button" mat-raised-button [disabled]="isSubmitButtonDisabled" (click)="submit()">
      @if (isSubmitTextShown) {
        <span>Submit</span>
      } @else {
        <mat-spinner diameter="20" />
      }
    </button>
  </div>
</div>
